import { render, staticRenderFns } from "./404.vue?vue&type=template&id=ba5c7864&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c7864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba5c7864')) {
      api.createRecord('ba5c7864', component.options)
    } else {
      api.reload('ba5c7864', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=ba5c7864&scoped=true", function () {
      api.rerender('ba5c7864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exception/404.vue"
export default component.exports